import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import {
  Box, Button, Typography,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

export function NotAuthorizedBox () {
  const { t } = useTranslation('components', { keyPrefix: 'not-authorized-box' });

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        padding: 3,
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          maxWidth: 600,
        }}
      >
        <LockOutlinedIcon
          color='primary'
          sx={{
            fontSize: 120,
            mb: 2,
          }}
        />
        <Typography
          sx={{ mb: 2 }}
          variant='h4'
        >
          {t('access_denied')}
        </Typography>
        <Typography
          sx={{
            mb: 4,
            color: 'text.secondary',
          }}
          variant='body1'
        >
          {t('access_denied_message')}
        </Typography>
        <Button
          component={Link}
          size='large'
          sx={{
            paddingX: 4,
            paddingY: 1.5,
          }}
          to='/'
          variant='contained'
        >
          {t('go_to_home')}
        </Button>
      </Box>
    </Box>
  );
}
